import { Routes, Route } from 'react-router-dom';
import PMNDPTableProgram from '../modules/pmndp/components/PMNDPTableProgram';
import MachineManagement from '../modules/pmndp/components/MachineManagement';
import SloatManagement from '../modules/pmndp/components/SloatManagement';

const PMNDPRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<PMNDPTableProgram />} />
      <Route path="/table" element={<PMNDPTableProgram />} />
      <Route path="/machine-management" element={<MachineManagement />} />
      <Route path="/slot-management" element={<SloatManagement />} />
    </Routes>
  );
};

export default PMNDPRoutes;